'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _isUrl = require('is-url');

var _isUrl2 = _interopRequireDefault(_isUrl);

var _components = require('components');

var _applications = require('redux/modules/applications');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_ERROR = 'Field cannot be empty';
var URL_ERROR = 'Invalid URL';

var CreateApplicationDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    creating: state.applications.application.creating,
    created: state.applications.application.created,
    creatingError: state.applications.application.creatingError
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(CreateApplicationDialog, _React$Component);

  function CreateApplicationDialog() {
    (0, _classCallCheck3.default)(this, CreateApplicationDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateApplicationDialog.__proto__ || (0, _getPrototypeOf2.default)(CreateApplicationDialog)).call(this));

    _this.state = {
      name: '',
      company: '',
      icon: '',
      description: '',

      errors: {
        name: '',
        company: '',
        icon: '',
        description: ''
      },

      active: {
        name: false,
        company: false,
        icon: false,
        description: false
      },

      touched: {
        name: true,
        company: true,
        icon: true,
        description: true
      }
    };
    return _this;
  }

  (0, _createClass3.default)(CreateApplicationDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          creating = _props.creating,
          created = _props.created;


      if (creating == false && created == false) this.refs.name.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _applications.resetCreateApplication)());
    }
  }, {
    key: 'setActive',
    value: function setActive(field) {
      var active = this.state.active;
      active[field] = true;

      this.setState({ active: active });
    }
  }, {
    key: 'unsetActive',
    value: function unsetActive(field) {
      var active = this.state.active;
      active[field] = false;

      this.setState({ active: active });
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.creating) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'onNameChange',
    value: function onNameChange(name) {
      var error = name.length <= 0;
      this.setState({ name: name, errors: (0, _extends3.default)({}, this.state.errors, { name: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'onCompanyChange',
    value: function onCompanyChange(company) {
      var error = company.length <= 0;
      this.setState({ company: company, errors: (0, _extends3.default)({}, this.state.errors, { company: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'onIconChange',
    value: function onIconChange(icon) {
      var error = icon.length <= 0;
      var error2 = !(0, _isUrl2.default)(icon);
      this.setState({ icon: icon, errors: (0, _extends3.default)({}, this.state.errors, { icon: error ? INPUT_ERROR : error2 ? URL_ERROR : '' }) });
    }
  }, {
    key: 'onDescriptionChange',
    value: function onDescriptionChange(e) {
      var description = e.target.value;
      var error = description.length <= 0;
      this.setState({ description: description, errors: (0, _extends3.default)({}, this.state.errors, { description: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'handleCreateClick',
    value: function handleCreateClick(e) {
      var dispatch = this.props.dispatch;


      e.preventDefault();
      e.stopPropagation();

      var _state = this.state,
          name = _state.name,
          company = _state.company,
          icon = _state.icon,
          description = _state.description;


      var nameError = name.length <= 0,
          companyError = company.length <= 0,
          iconError = icon.length <= 0,
          iconError2 = !(0, _isUrl2.default)(icon),
          descriptionError = description.length <= 0;

      if (nameError || companyError || iconError || iconError2 || descriptionError) {
        this.setState({ errors: {
            name: nameError ? INPUT_ERROR : '',
            company: companyError ? INPUT_ERROR : '',
            description: descriptionError ? INPUT_ERROR : '',
            icon: iconError ? INPUT_ERROR : iconError2 ? URL_ERROR : ''
          } });

        return;
      }

      dispatch((0, _applications.createApplication)({ name: name, company: company, icon: icon, description: description }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _classnames2,
          _this2 = this;

      var styles = require('./CreateApplicationDialog.scss');

      var _state$errors = this.state.errors,
          nameError = _state$errors.name,
          companyError = _state$errors.company,
          iconError = _state$errors.icon,
          descriptionError = _state$errors.description;
      var _state$active = this.state.active,
          nameActive = _state$active.name,
          companyActive = _state$active.company,
          iconActive = _state$active.icon,
          descriptionActive = _state$active.description;
      var _state$touched = this.state.touched,
          nameTouched = _state$touched.name,
          companyTouched = _state$touched.company,
          iconTouched = _state$touched.icon,
          descriptionTouched = _state$touched.description;
      var passwordError = this.state.passwordError;
      var _props2 = this.props,
          creating = _props2.creating,
          created = _props2.created,
          creatingError = _props2.creatingError;


      var classes = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.CreateApplicationDialog, true), (0, _defineProperty3.default)(_classnames, styles['CreateApplicationDialog--error'], creatingError), _classnames));

      var descriptionClasses = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles['Description__message'], true), (0, _defineProperty3.default)(_classnames2, styles['Input__error'], descriptionError), (0, _defineProperty3.default)(_classnames2, styles['Input__active'], descriptionActive), _classnames2));

      if (!!creatingError) {
        return _react2.default.createElement(
          _components.PopupBox,
          null,
          _react2.default.createElement(
            'div',
            { className: styles['CreateApplicationDialog__success-message'] },
            'Something went wrong. Please try again.'
          )
        );
      }

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        creating ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['CreateApplicationDialog__loading-indicator'] }) : created ? _react2.default.createElement(
          'div',
          { className: styles['CreateApplicationDialog__success-message'] },
          'Your application has been created!'
        ) : _react2.default.createElement(
          'form',
          { className: styles['Create__form'], onSubmit: this.handleCreateClick.bind(this) },
          _react2.default.createElement(_components.TextInput, { simpleError: true, active: nameActive, touched: nameTouched, error: nameError, className: styles['Create__form-input'], onChange: this.onNameChange.bind(this), type: 'name', title: 'Name', ref: 'name',
            onBlur: function onBlur() {
              return _this2.unsetActive('name');
            },
            onFocus: function onFocus() {
              return _this2.setActive('name');
            } }),
          _react2.default.createElement(_components.TextInput, { simpleError: true, active: companyActive, touched: companyTouched, error: companyError, className: styles['Create__form-input'], onChange: this.onCompanyChange.bind(this), type: 'company', title: 'Company',
            onBlur: function onBlur() {
              return _this2.unsetActive('company');
            },
            onFocus: function onFocus() {
              return _this2.setActive('company');
            } }),
          _react2.default.createElement(_components.TextInput, { simpleError: true, active: iconActive, touched: iconTouched, error: iconError, className: styles['Create__form-input'], onChange: this.onIconChange.bind(this), type: 'icon', title: 'Icon',
            onBlur: function onBlur() {
              return _this2.unsetActive('icon');
            },
            onFocus: function onFocus() {
              return _this2.setActive('icon');
            } }),
          _react2.default.createElement(
            'span',
            { className: styles.Icon__hint },
            'For example http://www.yourserver.com/icon.jpg'
          ),
          _react2.default.createElement(
            'div',
            { className: styles['Description__message-label'] },
            'Description'
          ),
          _react2.default.createElement('textarea', { rows: '2', className: descriptionClasses, onChange: this.onDescriptionChange.bind(this),
            onBlur: function onBlur() {
              return _this2.unsetActive('description');
            },
            onFocus: function onFocus() {
              return _this2.setActive('description');
            } }),
          passwordError && _react2.default.createElement(
            'p',
            { className: styles['CreateApplication__error'] },
            passwordError
          ),
          _react2.default.createElement(
            'div',
            { className: styles['CreateApplicationDialog__buttons'] },
            _react2.default.createElement(_components.Button, { type: 'button', className: styles['CreateApplicationDialog__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
            _react2.default.createElement(_components.Button, { primary: true, alternative: true, type: 'submit', className: styles['CreateApplicationDialog__button'], label: 'Create', onClick: this.handleCreateClick.bind(this) })
          )
        )
      );
    }
  }]);
  return CreateApplicationDialog;
}(_react2.default.Component)) || _class);
exports.default = CreateApplicationDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateApplicationDialog/CreateApplicationDialog.jsx
// module id = 2475
// module chunks = 0